import { render, staticRenderFns } from "./LogRocket.vue?vue&type=template&id=1ab08c15"
import script from "./LogRocket.vue?vue&type=script&lang=ts"
export * from "./LogRocket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports